module.exports = __webpack_public_path__ + "img/equipment-coat-02.b71f5e91.png";